import { makeAutoObservable } from 'mobx';
import { SelectedWorkingHourToPay } from '../../pages/salaries/salary-generator/salaries-generator-page';
import { UserSummaryType } from '../../api/types/user/user-summary.type';

class GlobalSalaryStore {
  private _selectedWorkingHourToPay: SelectedWorkingHourToPay[] = [];
  private _user: UserSummaryType | null = null;
  private _excludedTravelExpenseIds: number[] = [];
  constructor() {
    makeAutoObservable(this, {}, { deep: true }); // Just add deep: true
  }

  get selectedWorkingHourToPay(): SelectedWorkingHourToPay[] {
    return this._selectedWorkingHourToPay;
  }

  set selectedWorkingHourToPay(value: SelectedWorkingHourToPay[]) {
    this._selectedWorkingHourToPay = value;
    // When working hours are removed, also remove their travel expenses from excluded list
    const currentWorkingHourIds = new Set(
      value.map((item) => item.workingHourId),
    );
    this._excludedTravelExpenseIds = this._excludedTravelExpenseIds.filter(
      (id) => currentWorkingHourIds.has(id),
    );
  }

  get user(): UserSummaryType | null {
    return this._user;
  }

  set user(value: UserSummaryType | null) {
    this._user = value;
  }

  get excludedTravelExpenseIds(): Set<number> {
    return new Set(this._excludedTravelExpenseIds);
  }

  get excludedTravelExpenseIdsArray(): number[] {
    return this._excludedTravelExpenseIds;
  }

  excludeTravelExpense(workingHourId: number) {
    if (!this._excludedTravelExpenseIds.includes(workingHourId)) {
      this._excludedTravelExpenseIds = [
        ...this._excludedTravelExpenseIds,
        workingHourId,
      ];
    }
  }

  includeTravelExpense(workingHourId: number) {
    this._excludedTravelExpenseIds = this._excludedTravelExpenseIds.filter(
      (id) => id !== workingHourId,
    );
  }

  clearExcludedTravelExpenses() {
    this._excludedTravelExpenseIds = [];
  }
}

const globalSalaryStore = new GlobalSalaryStore();
export default globalSalaryStore;
